import React, { useEffect } from 'react';
import '../styles/AboutNamePage.css';
import logoImage from '../assets/FINAL LOGO AK.png';

const AboutName = () => {
  useEffect(() => {
    document.body.classList.add('about-name-body');
    return () => {
      document.body.classList.remove('about-name-body');
    };
  }, []);

  return (
    <div className="about-name-page">
      <div className="hero">
        <img src={logoImage} alt="AksharJobs logo" className="hero-logo" />
        <div className="hero-badge">About the Name</div>
        <h1>
          AKSHAR<span>JOBS</span>
        </h1>
        <p className="hero-tagline">"Where Talent Meets Opportunity"</p>
        <p className="hero-desc">
          In Sanskrit, <strong>Akshar (अक्षर)</strong> means <strong>'Letter', 'Indestructible'</strong> or{' '}
          <strong>'That which never fades.'</strong> For a jobs platform, this carries a powerful brand promise: your
          career is built on letters — your resume, your skills, your story. AksharJobs helps those letters speak louder.
        </p>
      </div>

      <div className="container">
        {/* Core Meaning */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Core Meaning —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Aspire</td>
                <td className="meaning-cell">Every job seeker starts with ambition — the drive to grow</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Knowledge</td>
                <td className="meaning-cell">Skills, expertise, and learning that candidates bring to the table</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Synergy</td>
                <td className="meaning-cell">The perfect match between employer needs and talent potential</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Hire</td>
                <td className="meaning-cell">The core transaction — connecting the right people to the right roles</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Achieve</td>
                <td className="meaning-cell">The outcome — careers built, businesses grown, goals reached</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Results</td>
                <td className="meaning-cell">Measurable value delivered to both candidates and companies</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* Job Seeker */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Job Seeker —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Aspire</td>
                <td className="meaning-cell">Dream bigger, aim for the role that defines you</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Knowledge</td>
                <td className="meaning-cell">Showcase your skills and stand out from the crowd</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Search</td>
                <td className="meaning-cell">Find opportunities that align with your passion and purpose</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Hope</td>
                <td className="meaning-cell">Every application is a step closer to your breakthrough</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Apply</td>
                <td className="meaning-cell">Take action — your next opportunity awaits</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Rise</td>
                <td className="meaning-cell">Grow in your career, income, and purpose</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* Employer / Recruiter */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Employer / Recruiter —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Attract</td>
                <td className="meaning-cell">Draw the best talent to your brand</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Know</td>
                <td className="meaning-cell">Understand who your ideal candidate truly is</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Screen</td>
                <td className="meaning-cell">Filter, shortlist, and find the perfect fit</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Hire</td>
                <td className="meaning-cell">Make confident, informed hiring decisions</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Assess</td>
                <td className="meaning-cell">Evaluate talent beyond just a resume</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Retain</td>
                <td className="meaning-cell">Build teams that stay, grow, and deliver</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* Volunteer */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Volunteer —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Act</td>
                <td className="meaning-cell">Step up and give your time for a cause</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Kindness</td>
                <td className="meaning-cell">Service driven by heart, not just skill</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Serve</td>
                <td className="meaning-cell">Contribute meaningfully to communities</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Humanity</td>
                <td className="meaning-cell">Volunteering keeps people and purpose connected</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Advocate</td>
                <td className="meaning-cell">Speak up, support, and champion change</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Reward</td>
                <td className="meaning-cell">Experience the fulfilment of giving back</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* Fresher / Student */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Fresher / Student —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Ambition</td>
                <td className="meaning-cell">Starting out with energy and fresh ideas</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Knowledge</td>
                <td className="meaning-cell">Academic learning meets real-world application</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Skill-up</td>
                <td className="meaning-cell">Build practical experience through internships and entry roles</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Hustle</td>
                <td className="meaning-cell">Hard work and persistence open every door</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Adapt</td>
                <td className="meaning-cell">Learn fast, grow faster in any environment</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Ready</td>
                <td className="meaning-cell">Prepared to launch a career that lasts</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* Agency / Staffing Partner */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Agency / Staffing Partner —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Alliance</td>
                <td className="meaning-cell">Partner with businesses to solve talent gaps</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Key</td>
                <td className="meaning-cell">Be the key connector between supply and demand</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Source</td>
                <td className="meaning-cell">Access a rich pipeline of verified candidates</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Handle</td>
                <td className="meaning-cell">Manage bulk hiring with speed and precision</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Accelerate</td>
                <td className="meaning-cell">Speed up recruitment cycles for clients</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Results</td>
                <td className="meaning-cell">Deliver placements that drive business forward</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="divider">· · ·</div>

        {/* University / Educational Institution */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— University / Educational Institution —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Academia</td>
                <td className="meaning-cell">The birthplace of talent, ideas, and innovation</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Knowledge Hub</td>
                <td className="meaning-cell">Universities are living libraries of human potential</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Shape</td>
                <td className="meaning-cell">Mould students into industry-ready professionals</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Handshake</td>
                <td className="meaning-cell">Bridge the gap between campus and corporate world</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Alumni</td>
                <td className="meaning-cell">A lifelong network that keeps giving back</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Research</td>
                <td className="meaning-cell">Driving discovery that powers tomorrow&apos;s workforce</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="note-block">
          Universities log in to post internships, campus drives, placement opportunities and connect faculty expertise
          with industry needs.
        </div>

        <div className="divider">· · ·</div>

        {/* NGO / Non-Profit */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— NGO / Non-Profit Organisation —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Awareness</td>
                <td className="meaning-cell">Raising voices for causes that matter most</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Kindred</td>
                <td className="meaning-cell">Connecting people united by shared values and mission</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Social Impact</td>
                <td className="meaning-cell">Every hire or volunteer placed creates community change</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Humanitarian</td>
                <td className="meaning-cell">People-first approach in everything they do</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Advocacy</td>
                <td className="meaning-cell">Championing rights, equity, and inclusion at every level</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Reach</td>
                <td className="meaning-cell">Expanding impact across communities, regions, and lives</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="note-block">
          NGOs log in to recruit passionate staff, onboard volunteers, post cause-driven campaigns and find skilled
          professionals willing to serve beyond profit.
        </div>

        <div className="divider">· · ·</div>

        {/* Business Association / Chamber of Commerce */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Business Association / Chamber of Commerce —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Alliance</td>
                <td className="meaning-cell">Uniting businesses under a common workforce agenda</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Knowledge Sharing</td>
                <td className="meaning-cell">Circulating industry insights, trends, and talent data</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Synergise</td>
                <td className="meaning-cell">Connecting member businesses for collective strength</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Harmonise</td>
                <td className="meaning-cell">Aligning workforce needs across an entire industry sector</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Amplify</td>
                <td className="meaning-cell">Boosting member visibility in the talent marketplace</td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Represent</td>
                <td className="meaning-cell">Speaking for the collective voice of an industry</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="note-block">
          Business Associations log in to promote member job listings, drive sector-wide hiring campaigns, organise job
          fairs and advocate workforce development policies.
        </div>

        <div className="divider">· · ·</div>

        {/* Community */}
        <div className="section-heading">
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— Community (Religious or Non-Religious) —</h2>
        </div>
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Letter</th>
                <th>Word</th>
                <th>Meaning</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Anchor</td>
                <td className="meaning-cell">Communities are the moral and social anchor of society</td>
              </tr>
              <tr>
                <td className="letter-cell">K</td>
                <td className="word-cell">Kinship</td>
                <td className="meaning-cell">Bound by shared faith, values, culture, or common purpose</td>
              </tr>
              <tr>
                <td className="letter-cell">S</td>
                <td className="word-cell">Serve</td>
                <td className="meaning-cell">Community bodies mobilise people to serve those most in need</td>
              </tr>
              <tr>
                <td className="letter-cell">H</td>
                <td className="word-cell">Harmony</td>
                <td className="meaning-cell">Fostering unity, respect, and inclusion across all beliefs</td>
              </tr>
              <tr>
                <td className="letter-cell">A</td>
                <td className="word-cell">Awaken</td>
                <td className="meaning-cell">
                  Inspiring individuals to discover meaningful purpose and vocation
                </td>
              </tr>
              <tr>
                <td className="letter-cell">R</td>
                <td className="word-cell">Root</td>
                <td className="meaning-cell">
                  Deep-rooted connections that sustain livelihoods and belonging
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="note-block">
          Community organisations — temples, mosques, churches, cultural societies, community trusts, resident welfare
          groups, and secular community bodies — log in to post service roles, connect volunteers and skilled members to
          local needs, run community employment drives, and support faith-based or value-driven livelihoods.
        </div>

        <div className="divider">· · ·</div>

        {/* Complete Ecosystem */}
        <div className="section-heading" style={{ marginTop: 20 }}>
          <div className="dots">
            <span className="dot-letter">A · K · S · H · A · R</span>
          </div>
          <h2>— The Complete Ecosystem —</h2>
        </div>
        <div className="eco-wrap">
          <table className="eco-table">
            <thead>
              <tr>
                <th>Login Type</th>
                <th>Core Role on Platform</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Job Seeker</td>
                <td className="meaning-cell">Find and apply for opportunities</td>
              </tr>
              <tr>
                <td>Fresher / Student</td>
                <td className="meaning-cell">Launch career through internships and entry roles</td>
              </tr>
              <tr>
                <td>Employer / Recruiter</td>
                <td className="meaning-cell">Post jobs and hire talent</td>
              </tr>
              <tr>
                <td>Staffing Agency</td>
                <td className="meaning-cell">Manage bulk placements and client mandates</td>
              </tr>
              <tr>
                <td>Volunteer</td>
                <td className="meaning-cell">Offer time, skills, and service to causes</td>
              </tr>
              <tr>
                <td>University</td>
                <td className="meaning-cell">Drive campus placements and industry linkages</td>
              </tr>
              <tr>
                <td>NGO</td>
                <td className="meaning-cell">Recruit mission-driven staff and volunteers</td>
              </tr>
              <tr>
                <td>Business Association</td>
                <td className="meaning-cell">Represent industries and amplify member hiring</td>
              </tr>
              <tr>
                <td>Community (Religious or Non-Religious)</td>
                <td className="meaning-cell">
                  Connect members to service roles, vocations, and local opportunities
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Quote */}
        <div className="quote-block">
          <p>
            AKSHARJOBS is not just a jobs platform — it is an entire living ecosystem where seekers, builders, givers,
            educators, advocates, and leaders all find their place. Like the letters of a language, every user type is
            essential. Remove one, and the story is incomplete.
          </p>
          <div className="quote-attr">— AksharJobs Team</div>
        </div>

        {/* Final Statement */}
        <div className="final-stmt">
          In Sanskrit, <strong>Akshar = Indestructible Letter.</strong> Every institution, individual, and community
          that joins the platform adds a permanent, meaningful character to a larger story of human progress.
        </div>
      </div>

      <footer>
        © 2026 Maxpro Infotech Ltd. All rights reserved.
      </footer>
    </div>
  );
};

export default AboutName;
